import styled from 'styled-components';

const ReadViewWrapper = styled.div`
  line-height: 1;
`;

ReadViewWrapper.displayName = 'ReadViewWrapper';

export default ReadViewWrapper;
